export { addToFolderEventAction } from 'next-flight-server-reference-proxy-loader?id=4002d56031887d3a64438b8c35899ade69703d9f68&name=addToFolderEventAction!'